import { Modal, ModalFooterAction } from "components/primitives/Modal";
import { DashboardContext } from "contexts/DashboardContext";
import { ModalsContext } from "contexts/ModalsContext";
import { useContext } from "react";
import styled from "styled-components";

import { MODAL_DELETE_WORD_LIST } from "./constatnts";
import { ModalDeleteHeader } from "./ModalHeaders";

export const ModalDeleteWordList = () => {
  const modalsContext = useContext(ModalsContext);
  const { data, setData: setGlobalData } = useContext(DashboardContext);

  const handleDelete = () => {
    const filteredData = data.saveWords.filter((word) => {
      return modalsContext.modalData.id !== word.id;
    });

    setGlobalData({ saveWords: filteredData });
    modalsContext.closeModal();
  };

  const handleClose = () => {
    modalsContext.closeModal();
  };

  const footerActions: ModalFooterAction[] = [
    {
      key: "cancel",
      textBtn: "Cancel",
      color: "var(--primary)",
      action: handleClose,
    },
    {
      key: "delete",
      textBtn: "Delete",
      color: "var(--danger)",
      action: handleDelete,
    },
  ];

  return (
    <Modal
      isOpen={modalsContext.modalData.name === MODAL_DELETE_WORD_LIST}
      header={ModalDeleteHeader}
      footerActions={footerActions}
    >
      <MessageBox>
        <p>Are you sure you want to delete this Name List?</p>
        <p>This action is permanent.</p>
      </MessageBox>
    </Modal>
  );
};

const MessageBox = styled("div")`
  text-align: center;
  margin-top: 20px;
`;
